import { Injectable } from '@angular/core';
import { noticeboardApi } from '../../constants/notice-board-api';
import { HttpClientService } from '../httpClient/httpClient.service';
import { Observable } from 'rxjs/internal/Observable';
import Swal from 'sweetalert2';
import { userParams } from '../../helpers/helperfunc';
import { PermissionsPipe } from '../../pipe/permissions.pipe';
import { permissionEntity } from '../../constants/permission';
@Injectable({
    providedIn: 'root',
})
export class NoticeBoardService {
    permissions_entity = permissionEntity;

    constructor(
        private httpClientService: HttpClientService,
        private _permissionPipe: PermissionsPipe // dont remove this
    ) { }

    getAdminNoticeList(pagination: any, userType: any, referenceModule: any): Observable<any> {
        let query = '?';
        query += `userType=${userType}`;
        query += `&referenceModule=${referenceModule}`;
        query += `&skip=${pagination.skip}&limit=${pagination.limit}`;
        return this.httpClientService.get(
            `${noticeboardApi.getMainAdminNotice}${query}`
        );
    }

    deletefromList(id: string): Observable<any> {
        return this.httpClientService.delete(
            `${noticeboardApi.deleteNotice}/?id=${id}`
        );
    }

    public showConfirmationPopup(
        title: string,
        message: string,
        confirmButtonText: string,
        callback: (confirmed: boolean) => void,
        isHTML: boolean = false,
        cancelButtonText: string | undefined = undefined
    ) {
        Swal.fire({
            title: title,
            text: message,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: confirmButtonText,
            cancelButtonText: cancelButtonText ?? undefined,
        }).then((result) => {
            callback(result.isConfirmed);
        });
    }

    getAgentNoticeList(
        pagination: any,
        userType: any,
        referenceModule: any
    ): Observable<any> {
        let query = '?';
        query += `userType=${userType}`;
        query += `&referenceModule=${referenceModule}`;
        query += `&skip=${pagination.skip}&limit=${pagination.limit}`;
        return this.httpClientService.get(
            `${noticeboardApi.getAdminNoticeByPublish}${query}`
        );
    }

    getAgentWebinarList(
        pagination: any,
        userType: any,
        referenceModule: any
    ): Observable<any> {
        let query = '?';
        query += `userType=${userType}`;
        query += `&referenceModule=${referenceModule}`;
        query += `&skip=${pagination.skip}&limit=${pagination.limit}`;
        return this.httpClientService.get(
            `${noticeboardApi.getAdminNoticeByPublish}${query}`
        );
    }

    postAdminNotice(payload: any): Observable<any> {
        return this.httpClientService.post(
            `${noticeboardApi.createAdminNotice}`,
            payload
        );
    }

    postAgentNotice(
        payload: any,
        userType: string = 'agent',
        referenceModule: string = 'notice'
    ): Observable<any> {
        return this.httpClientService.post(
            `${noticeboardApi.createAdminNotice}`,
            payload
        );
    }

    getNoticeByID(
        id: any,
        userType: any,
        referenceModule: any
    ): Observable<any> {
        return this.httpClientService.get(
            `${noticeboardApi.getMainAdminNoticeByID}?userType=${userType}&id=${id}&referenceModule=${referenceModule}`
        );
    }

    getAdminNoticeByID(id: any, userType: any): Observable<any> {
        return this.httpClientService.get(
            `${noticeboardApi.getNoticeByIDAdmin}?userType=${userType}&id=${id}`
        );
    }

    getTenantByID(id: any): Observable<any> {
        return this.httpClientService.get(
            `${noticeboardApi.getNoticeByID}${id}`
        );
    }

    updateNotice(id: string, payload: unknown): Observable<any> {
        return this.httpClientService.put(
            `${noticeboardApi.updateNotice}?id=${id}`,
            payload
        );
    }

    updateWebinarNotice(
        id: string,
        userType: any,
        referenceModule: any,
        payload: unknown
    ): Observable<any> {
        return this.httpClientService.put(
            `${noticeboardApi.updateNotice
            }?userType=${userType}&id=${id.toString()}&referenceModule=${referenceModule}`,
            payload
        );
    }

    postAgentWebinar(
        payload: any,
        userType: string = 'agent',
        referenceModule: any
    ): Observable<any> {
        return this.httpClientService.post(
            `${noticeboardApi.createAdminNotice}?userType=${userType}&referenceModule=${referenceModule}`,
            payload
        );
    }

    getNoticePopup(userId): Observable<any> {
        return this.httpClientService.get(
            `${noticeboardApi.seenNotice}?userId=${userId}&referenceModule=adminNotice`
        );
    }

    noticeSeenAdmin(id, payload): Observable<any> {
        return this.httpClientService.put(
            `${noticeboardApi.noticeSeenAdmin}?id=${id}`,
            payload
        );
    }

    getById(id): Observable<any> {
        return this.httpClientService.get(`${noticeboardApi.getById}?id=${id}`);
    }

    getNotification(
        pagination: any = {},
        isRead: string = '',
        referenceModule: string = 'application',
        filter: any = {}
    ): Observable<any> {
        let query = '?';
        query += `skip=${pagination.skip || 0}&limit=${pagination.limit || 5
            }&referenceModule=${referenceModule}`;
        if (isRead) {
            query += `&isRead=${isRead}`;
        }
        if (filter) {
            Object.keys(filter).map((key) => {
                query += filter[key] && `&${key}=${filter[key]}`;
            });
        }

        return this.httpClientService.get(
            `${noticeboardApi.getNotification}${query}`
        );
    }

    getTimeDifference(createdTime: number): string {
        const createdDate = new Date(createdTime * 1000);
        const currentDate = new Date();

        const diffInMilliseconds =
            currentDate.getTime() - createdDate.getTime();
        const diffInMinutes = Math.floor(diffInMilliseconds / 60000);
        const diffInHours = Math.floor(diffInMinutes / 60);
        const diffInDays = Math.floor(diffInHours / 24);

        if (diffInDays > 0) {
            const hours = diffInHours % 24;
            return `${diffInDays} day${diffInDays !== 1 ? 's' : ''
                } ${hours} hour${hours !== 1 ? 's' : ''} ago`;
        } else if (diffInHours > 0) {
            const minutes = diffInMinutes % 60;
            return `${diffInHours} hour${diffInHours !== 1 ? 's' : ''
                } ${minutes} minute${minutes !== 1 ? 's' : ''} ago`;
        } else {
            return `${diffInMinutes} minute${diffInMinutes !== 1 ? 's' : ''
                } ago`;
        }
    }

    updateNotification(
        notificationId: string,
        status: boolean = false
    ): Observable<any> {
        return this.httpClientService.put(
            `${noticeboardApi.updateNotification}?id=${notificationId}`,
            {
                isRead: status,
            }
        );
    }

    showAgentNotice(
        noticeId: string,
    ): Observable<any> {
        return this.httpClientService.put(
            `${noticeboardApi.showAgentNotification}?noticeId=${noticeId}`, {}
        );
    }

    getUserGroupJobRole(pagination?: any): Observable<any> {
        let query = '?';
        query += `skip=${pagination?.skip}&limit=${pagination?.limit}`;
        return this.httpClientService.get(
            `${noticeboardApi.getUserGroupJobRole}${query}`
        );
    }

    uploadBirthdayImage(id: any, payload: any, notice: any): Observable<any> {
        return this.httpClientService.upload(
            `${noticeboardApi.uploadBirthDayDoc}?id=${id}&noticeType=${notice}`,
            payload
        );
    }

    getNoticeBirthDayPopup(referenceModule: string, cUser: any, showPopup, pagination): Observable<any> {
        let query = '&';
        query += `skip=${pagination?.skip}&limit=${pagination?.limit}`;
        return this.httpClientService.get(
            `${noticeboardApi.getNoticeBirthDayPopup}&referenceModule=${referenceModule}&userGroup=${cUser}&isShowPopUp=${showPopup}${query}`
        );
    }

    getNoticeMarkAsRead(id: any, payload: any): Observable<any> {
        return this.httpClientService.put(
            `${noticeboardApi.getNoticeMarkAsRead}?id=${id}`, payload
        );
    }
}
